import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const scrollToBeta = () => {
    if (location.pathname === '/') {
      const betaSection = document.getElementById('beta-signup');
      if (betaSection) {
        betaSection.scrollIntoView({ behavior: 'smooth' });
      }
    } else {
      window.location.href = '/#beta-signup';
    }
    setIsMenuOpen(false);
  };

  return (
    <nav className="bg-white shadow-sm fixed w-full top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <span className="text-2xl font-bold text-secondary">A</span>
            </div>
            <span className="text-xl font-bold text-secondary">
              AdOnRoads<span className="text-primary">.com</span>
            </span>
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            <Link
              to="/"
              className="text-secondary hover:text-primary transition-colors font-medium"
            >
              Home
            </Link>
            <Link
              to="/contact"
              className="text-secondary hover:text-primary transition-colors font-medium"
            >
              Contact
            </Link>
            <button
              onClick={scrollToBeta}
              className="bg-accent text-white px-6 py-2 rounded-full font-semibold hover:bg-opacity-90 transition-all hover:scale-105"
            >
              Join Beta
            </button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="md:hidden text-secondary focus:outline-none"
            aria-label="Toggle menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              {isMenuOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="md:hidden bg-white border-t"
          >
            <div className="px-4 py-4 space-y-3">
              <Link
                to="/"
                onClick={() => setIsMenuOpen(false)}
                className="block py-2 text-secondary hover:text-primary transition-colors font-medium"
              >
                Home
              </Link>
              <Link
                to="/contact"
                onClick={() => setIsMenuOpen(false)}
                className="block py-2 text-secondary hover:text-primary transition-colors font-medium"
              >
                Contact
              </Link>
              <button
                onClick={scrollToBeta}
                className="w-full bg-accent text-white px-6 py-3 rounded-full font-semibold hover:bg-opacity-90 transition-all"
              >
                Join Beta
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Navbar;
